﻿// /assets/js/overlays.toggle.mutex.labels.mobile-aware.js
(function (root, factory) {
    var api = factory(root);
    if (typeof module === 'object' && module && module.exports) module.exports = api;
    else root.OverlaysToggle = api;
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
    'use strict';

    var IDS = {
        translateBtn: 'translate',
        contactBtn: 'contact-expand',
        translateOverlay: 'google_translate_element_container', // outer overlay
        contactOverlay: 'contact-footer-section'
    };

    var CONFIG = { labelSwapBreakpoint: 768 };

    function alreadyWired(el) { return el && el.dataset && el.dataset.overlayWired === '1'; }
    function markWired(el) { if (el && el.dataset) el.dataset.overlayWired = '1'; }

    function show(el) {
        if (!el) return;
        el.removeAttribute('hidden');
        el.classList.remove('hidden', 'd-none');
        el.style.removeProperty('display');
        if (getComputedStyle(el).display === 'none') el.style.display = 'block';
    }
    function hide(el) { if (el) el.style.display = 'none'; }
    function isOpen(el) {
        if (!el) return false;
        var cs = getComputedStyle(el);
        return cs.display !== 'none' && cs.visibility !== 'hidden';
    }
    function isMobile() {
        return typeof window !== 'undefined' &&
            window.matchMedia &&
            window.matchMedia('(max-width: ' + CONFIG.labelSwapBreakpoint + 'px)').matches;
    }

    var ICON_SEL = '.fa, .fa-solid, .fa-regular, .fa-brands, [class*="fa-"], .icon, [data-icon]';
    function getIconHTML(btn) {
        var icon = btn ? btn.querySelector(ICON_SEL) : null;
        return icon ? icon.outerHTML : '';
    }
    function readLabel(btn) {
        if (!btn) return '';
        var clone = btn.cloneNode(true);
        var icon = clone.querySelector(ICON_SEL);
        if (icon) icon.remove();
        return (clone.textContent || '').trim();
    }
    function setButtonLabel(btn, text) {
        if (!btn) return;
        var iconHTML = getIconHTML(btn);
        btn.innerHTML = (iconHTML ? iconHTML + ' ' : '') + (text ? text : '');
    }

    // --- Google Translate lazy loader
    var GT = {
        status: 'idle', // 'idle' | 'loading' | 'ready' | 'error'
        ensureHost: function (overlay) {
            if (!overlay) return null;
            var host = overlay.querySelector('#google_translate_element');
            if (!host) {
                host = document.createElement('div');
                host.id = 'google_translate_element';
                overlay.appendChild(host);
            }
            return host;
        },
        loadOnce: function (overlay, pageLang) {
            if (this.status === 'ready') return Promise.resolve(true);
            if (this.status === 'loading') {
                return new Promise(function (resolve, reject) {
                    var check = setInterval(function () {
                        if (GT.status === 'ready') { clearInterval(check); resolve(true); }
                        if (GT.status === 'error') { clearInterval(check); reject(new Error('GT load error')); }
                    }, 50);
                });
            }
            this.status = 'loading';
            this.ensureHost(overlay);
            // Why: Google script calls window.googleTranslateElementInit as callback.
            window.googleTranslateElementInit = function () {
                try {
                    var lang = pageLang || (document.documentElement.getAttribute('lang') || 'en').split('-')[0];
                    new google.translate.TranslateElement({ pageLanguage: lang }, 'google_translate_element');
                    GT.status = 'ready';
                } catch (e) {
                    GT.status = 'error';
                    console.error('[OverlaysToggle] Translate init failed', e);
                }
            };
            return new Promise(function (resolve, reject) {
                var s = document.createElement('script');
                s.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
                s.async = true;
                s.onerror = function () { GT.status = 'error'; reject(new Error('GT network error')); };
                s.onload = function () {
                    // onload fires before cb; cb will set status to 'ready'
                    var wait = setInterval(function () {
                        if (GT.status === 'ready') { clearInterval(wait); resolve(true); }
                        if (GT.status === 'error') { clearInterval(wait); reject(new Error('GT init error')); }
                    }, 50);
                };
                document.head.appendChild(s);
            });
        }
    };

    // Optional: wait for element injected later
    function waitForEl(selector, timeoutMs, cb) {
        var el = document.querySelector(selector);
        if (el) { cb(el); return; }
        var to = null;
        var obs = new MutationObserver(function () {
            var found = document.querySelector(selector);
            if (found) {
                obs.disconnect();
                if (to) clearTimeout(to);
                cb(found);
            }
        });
        obs.observe(document.documentElement || document.body, { childList: true, subtree: true });
        if (timeoutMs) to = setTimeout(function () { obs.disconnect(); }, timeoutMs);
    }

    function init() {
        if (typeof window === 'undefined' || typeof document === 'undefined') return;
        if (window.__overlaysInitDone) return;
        window.__overlaysInitDone = true;

        var tBtn = document.getElementById(IDS.translateBtn);
        var cBtn = document.getElementById(IDS.contactBtn);
        var tOv = document.getElementById(IDS.translateOverlay);
        var cOv = document.getElementById(IDS.contactOverlay);

        if (console && console.warn) {
            var missing = {
                translateBtn: !!tBtn, translateOverlay: !!tOv,
                contactBtn: !!cBtn, contactOverlay: !!cOv
            };
            if (!missing.translateBtn || !missing.translateOverlay || !missing.contactBtn || !missing.contactOverlay) {
                console.warn('[OverlaysToggle] Missing elements:', missing);
            }
        }

        var translateClosedLabel = readLabel(tBtn);
        var translateOpenLabel = (tBtn && tBtn.getAttribute('data-label-open')) || 'Close';
        var contactClosedLabel = readLabel(cBtn);
        var contactOpenLabel = (cBtn && cBtn.getAttribute('data-label-open')) || 'Close';

        function setTranslate(open) {
            if (!tBtn || !tOv) return;
            if (open) {
                show(tOv);
                tBtn.setAttribute('aria-expanded', 'true');
                if (!isMobile()) setButtonLabel(tBtn, translateOpenLabel);
            } else {
                hide(tOv);
                tBtn.setAttribute('aria-expanded', 'false');
                if (!isMobile()) setButtonLabel(tBtn, translateClosedLabel);
            }
        }

        function setContact(open) {
            if (!cBtn || !cOv) return;
            if (open) {
                cOv.classList.add('contact-open');
                show(cOv);
                cBtn.setAttribute('aria-expanded', 'true');
                if (!isMobile()) setButtonLabel(cBtn, contactOpenLabel);
            } else {
                cOv.classList.remove('contact-open');
                hide(cOv);
                cBtn.setAttribute('aria-expanded', 'false');
                if (!isMobile()) setButtonLabel(cBtn, contactClosedLabel);
            }
        }

        // --- Translate toggle: lazy-load Google on first open
        var translatePrimed = false;
        if (tBtn && tOv && !alreadyWired(tBtn)) {
            markWired(tBtn);
            tBtn.setAttribute('aria-controls', IDS.translateOverlay);
            tBtn.addEventListener('click', function (e) {
                e.preventDefault();
                var willOpen = !isOpen(tOv);
                if (willOpen && isOpen(cOv)) setContact(false);

                // First open: ensure host + load Google widget once
                if (willOpen && !translatePrimed) {
                    translatePrimed = true;
                    GT.ensureHost(tOv);
                    GT.loadOnce(tOv /* overlay */, (document.documentElement.getAttribute('lang') || 'en'))
                        .catch(function (err) { console.error('[OverlaysToggle] Google loader error:', err); })
                        .finally(function () {
                            setTranslate(true);
                            if (tOv && typeof tOv.scrollIntoView === 'function') {
                                try { tOv.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
                                catch (_) { tOv.scrollIntoView(true); }
                            }
                        });
                    return; // defer show until loader finishes/finally calls setTranslate(true)
                }

                setTranslate(willOpen);

                if (willOpen && tOv && typeof tOv.scrollIntoView === 'function') {
                    try { tOv.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
                    catch (_) { tOv.scrollIntoView(true); }
                }
            });
        }

        // --- Contact toggle
        function wireContactIfReady() {
            if (!cBtn || !cOv || alreadyWired(cBtn)) return;
            markWired(cBtn);
            cBtn.setAttribute('aria-controls', IDS.contactOverlay);
            cBtn.addEventListener('click', function (e) {
                e.preventDefault();
                var willOpen = !isOpen(cOv);
                if (willOpen && isOpen(tOv)) setTranslate(false);
                setContact(willOpen);
                if (willOpen && cOv && typeof cOv.scrollIntoView === 'function') {
                    try { cOv.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
                    catch (_) { cOv.scrollIntoView(true); }
                }
            });
        }
        wireContactIfReady();

        if (!cOv && cBtn) {
            waitForEl('#' + IDS.contactOverlay, 10000, function (found) {
                cOv = found;
                wireContactIfReady();
                if (console && console.debug) console.debug('[OverlaysToggle] Contact overlay attached late');
            });
        }

        // Close buttons inside translate overlay
        if (tOv) {
            tOv.querySelectorAll('.translation-close-btn').forEach(function (btn) {
                if (alreadyWired(btn)) return;
                markWired(btn);
                btn.addEventListener('click', function (e) {
                    e.preventDefault();
                    setTranslate(false);
                });
            });
        }

        // Close buttons inside contact overlay
        function wireContactClosers() {
            if (!cOv) return;
            cOv.querySelectorAll('.contact-close-btn').forEach(function (btn) {
                if (alreadyWired(btn)) return;
                markWired(btn);
                btn.addEventListener('click', function (e) {
                    e.preventDefault();
                    setContact(false);
                });
            });
        }
        wireContactClosers();
        if (!cOv && cBtn) {
            waitForEl('#' + IDS.contactOverlay, 10000, function () { wireContactClosers(); });
        }

        // Global inline fallback
        if (typeof window.translationToggle !== 'function') {
            window.translationToggle = function () {
                var willOpen = !isOpen(tOv);
                if (willOpen && isOpen(cOv)) setContact(false);
                // prime GT on first open if needed
                if (willOpen && !translatePrimed) {
                    translatePrimed = true;
                    GT.ensureHost(tOv);
                    GT.loadOnce(tOv).finally(function () { setTranslate(true); });
                } else {
                    setTranslate(willOpen);
                }
            };
        }

        // Label swap on breakpoint changes
        if (window.matchMedia) {
            var mq = window.matchMedia('(max-width: ' + CONFIG.labelSwapBreakpoint + 'px)');
            if (!alreadyWired(mq)) {
                markWired(mq);
                mq.addEventListener('change', function () {
                    if (isMobile()) {
                        if (tBtn) setButtonLabel(tBtn, translateClosedLabel);
                        if (cBtn) setButtonLabel(cBtn, contactClosedLabel);
                    } else {
                        if (tBtn) setButtonLabel(tBtn, isOpen(tOv) ? translateOpenLabel : translateClosedLabel);
                        if (cBtn) setButtonLabel(cBtn, isOpen(cOv) ? contactOpenLabel : contactClosedLabel);
                    }
                });
            }
        }

        if (console && console.debug) console.debug('[OverlaysToggle] init complete (with Google lazy-load)');
    }

    if (typeof document !== 'undefined') {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init, { once: true });
        } else {
            init();
        }
    }

    return { init: init };
});
